import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const scenarios = [{
    image: 'https://cdn.magicpatterns.com/uploads/vpwm3qM1g9g2f2inGunb3B/1_plan_antipantalla_cover.png',
    time: '6:40 pm',
    title: 'El Momento Crítico',
    description: 'Estás preparando la cena. Tu hijo está inquieto. La tablet está ahí... tentadora.',
    emotion: 'Culpa anticipada'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/nzauFGRAhagRyh3yRisdtH/2_plan_antipantalla_cover.png',
    time: '7:15 pm',
    title: 'La Negociación Infinita',
    description: '"5 minutos más, mamá". Pero sabes que serán 30. Y la hora de dormir se retrasa.',
    emotion: 'Frustración'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/4m2nCvGqLHg38AvrR8RP8J/3_plan_antipantalla_cover.png',
    time: '8:00 pm',
    title: 'El Ciclo se Repite',
    description: 'Prometes que mañana será diferente. Pero a las 6:40 pm... vuelve a pasar.',
    emotion: 'Desesperanza'
  }];
  return <section className="relative py-20 overflow-hidden bg-gradient-to-b from-brand-offwhite to-white" data-id="element-634">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02]" data-id="element-635">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, #D32F2F 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} data-id="element-636" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-637">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-638">
          <div className="inline-block px-5 py-2 bg-brand-red/10 text-brand-red rounded-full font-bold text-sm mb-6 border border-brand-red/20" data-id="element-639">
            ¿Te suena familiar?
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-4 font-serif" data-id="element-640">
            El Ciclo que Conoces
            <span className="block text-brand-red italic mt-2" data-id="element-641">
              Demasiado Bien
            </span>
          </h2>

          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed mb-3" data-id="element-642">
            Cada tarde es la misma historia. No es falta de amor. No es falta de
            intención.
          </p>
          <p className="text-xl font-semibold text-brand-navy" data-id="element-643">
            Es falta de un sistema que funcione.
          </p>
        </motion.div>

        {/* Image scenarios grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-644">
          {scenarios.map((scenario, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.2
        }} className="group" data-id="element-645">
              {/* Image container */}
              <div className="relative mb-6 overflow-hidden rounded-2xl shadow-xl" data-id="element-646">
                <div className="aspect-[4/5] relative" data-id="element-647">
                  <img src={scenario.image} alt={scenario.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-648" />

                  {/* Overlay gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-649" />

                  {/* Time badge */}
                  <div className="absolute top-4 left-4 bg-brand-red text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2" data-id="element-650">
                    <Clock className="w-4 h-4" data-id="element-651" />
                    <span className="font-bold text-sm" data-id="element-652">{scenario.time}</span>
                  </div>

                  {/* Title overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-653">
                    <h3 className="text-2xl font-bold text-white mb-2 font-serif" data-id="element-654">
                      {scenario.title}
                    </h3>
                  </div>
                </div>
              </div>

              {/* Content card */}
              <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-brand-red/10" data-id="element-655">
                <p className="text-slate-700 leading-relaxed mb-4" data-id="element-656">
                  {scenario.description}
                </p>

                <div className="flex items-center gap-2 px-4 py-2 bg-brand-red/5 rounded-full text-sm" data-id="element-657">
                  <AlertCircle className="w-4 h-4 text-brand-red" data-id="element-658" />
                  <span className="text-brand-red font-medium" data-id="element-659">Emoción:</span>
                  <span className="text-brand-navy italic" data-id="element-660">
                    {scenario.emotion}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom message */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-661">
          <div className="bg-gradient-to-br from-brand-navy/5 to-brand-red/5 rounded-2xl p-8 md:p-10 border-2 border-brand-navy/10" data-id="element-662">
            <p className="text-2xl md:text-3xl font-serif text-brand-navy mb-4 italic" data-id="element-663">
              "No necesitas más fuerza de voluntad."
            </p>
            <p className="text-lg text-slate-700 leading-relaxed" data-id="element-664">
              Necesitas un{' '}
              <span className="font-semibold text-brand-navy" data-id="element-665">
                sistema elegante
              </span>{' '}
              que funcione incluso cuando estás cansada. Que sea tan fácil que
              tu hijo lo pida. Que transforme el caos en{' '}
              <span className="font-semibold text-brand-red" data-id="element-666">
                calma predecible.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}